import Vue from 'vue'
import Router from 'vue-router'

import views from '@/views'

import { get } from '@/data'

const router = new Router({
  mode: 'history',
  routes: [],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

get('routes', true).then((data) => {
  const wpRoutes = data
  let vueRoutes = []
  wpRoutes.forEach((route) => {
    vueRoutes.push({
      path: route.path,
      name: route.name ? route.name : undefined,
      props: {
        lang: route.lang,
        post_type: route.post_type,
        post_id: route.post_id
      },
      component: route.component !== '' ? views[route.component] : route.post_type !== 'page' && views[`single-${route.post_type}`] ? views[`single-${route.post_type}`] : views['tpl-default']
    })
  })

  vueRoutes.push({
    path: '*',
    name: 'not-found',
    component: views['not-found']
  })

  router.addRoutes(vueRoutes)
})

Vue.use(Router)

router.beforeEach((to, from, next) => {
  if (typeof window !== 'undefined') {
    window.prerenderReady = false
  }
  next()
})

export default router
